import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
<svg width={props.width || "31"} height={ props.height || "30"} viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_830_2982" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="30">
<path d="M0.75 1.90735e-06H30.75V30H0.75V1.90735e-06Z" fill="white"/>
</mask>
<g mask="url(#mask0_830_2982)">
<path d="M5.4375 27.8885H26.0625C28.0041 27.8885 29.5781 26.3145 29.5781 24.3729C29.5781 23.7477 29.4149 23.1606 29.1288 22.6518L18.8163 3.90185C18.2138 2.83081 17.0664 2.10729 15.75 2.10729C14.4336 2.10729 13.2862 2.83081 12.6837 3.90185L2.37123 22.6518C2.08512 23.1606 1.92188 23.7477 1.92188 24.3729C1.92188 26.3145 3.49588 27.8885 5.4375 27.8885Z" stroke="#FB6514" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.75 10.3104V17.3417" stroke="#FB6514" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.9219 22.0292C16.9219 22.6764 16.3972 23.201 15.75 23.201C15.1028 23.201 14.5781 22.6764 14.5781 22.0292C14.5781 21.382 15.1028 20.8573 15.75 20.8573C16.3972 20.8573 16.9219 21.382 16.9219 22.0292Z" fill="#FB6514"/>
</g>
</svg>

);

export default SvgComponent;
